import { render } from "./FileReferencesTable.vue?vue&type=template&id=3157b85f&scoped=true"
import script from "./FileReferencesTable.vue?vue&type=script&lang=js"
export * from "./FileReferencesTable.vue?vue&type=script&lang=js"

import "./FileReferencesTable.vue?vue&type=style&index=0&id=3157b85f&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3157b85f"]])

export default __exports__